import * as amplitude from '@amplitude/analytics-browser';

import { type Network, type User, type Admin } from 'hb-react/types';

interface ConnectAmplitude {
  currentAdmin?: Admin | null;
  currentNetwork: Partial<Network> & Pick<Network, 'id'>;
  currentUser: User | null;
}

export const connectAmplitude = ({
  currentNetwork,
  currentUser,
  currentAdmin,
}: ConnectAmplitude) => {
  if (
    window.__HB_ENV__.ENVIRONMENT === 'test' ||
    !window.__HB_ENV__.AMPLITUDE_API_KEY
  ) {
    return;
  }

  amplitude.init(window.__HB_ENV__.AMPLITUDE_API_KEY, undefined, {
    logLevel:
      process.env.NODE_ENV === 'development'
        ? amplitude.Types.LogLevel.Debug
        : amplitude.Types.LogLevel.Error,
    trackingOptions: {
      ipAddress: false,
    },
  });

  // SessionId could be passed from Mobile Gen2.
  const sessionId =
    // @ts-expect-error untyped window
    window.HivebriteMobileApp?.v2?.getConfig('amplitudeSessionId');

  if (sessionId) {
    amplitude.setSessionId(sessionId);
  }

  // @ts-expect-error untyped AlumniConnect Helpers
  const linkedToAdmin = AlumniConnect?.Helpers?.LoggedAs;
  const networkId = currentNetwork.id;

  const identify = new amplitude.Identify()
    .setOnce('network', networkId)
    .setOnce('env', window.__HB_ENV__.CLUSTER_NAME)
    .setOnce('Env&NetworkId', `${window.__HB_ENV__.CLUSTER_NAME} ${networkId}`)
    .set('LinkedToAdmin', linkedToAdmin);

  if (currentUser) {
    identify
      .set('NumberOfGroupsJoined', currentUser.followed_topics_count)
      .set('NumberOfVisits', currentUser.sign_in_count);
    amplitude.setUserId(currentUser.guid);
  }
  if (currentAdmin?.guid) {
    amplitude.setUserId(currentAdmin.guid);
  }
  amplitude.identify(identify);
};
